import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import { Download } from "lucide-react";

export default function PaymentSuccess({ onLoginClick }) {

    const [searchParams] = useSearchParams();
    const orderId = searchParams.get("order_id");

    const [booking, setBooking] = useState(null);

    // const calculateCharges = (base) => {
    //     const serviceCharge = base * SERVICE_CHARGE;
    //     const vat = base * VAT;
    //     const tourismFee = TOURISM_FEE;

    const calculateCharges = (base) => {
        const serviceCharge = base * SERVICE_CHARGE;
        const vat = base * VAT;

        const tourismFee = getTourismFee();

        const total = base + serviceCharge + vat + tourismFee;

        return {
            base: Math.round(base),
            serviceCharge: Math.round(serviceCharge),
            vat: Math.round(vat),
            tourismFee: Math.round(tourismFee),
            total: Math.round(total)
        };
    };

    // const SERVICE_CHARGE = 0.10;
    // const VAT = 0.05;
    // const TOURISM_FEE = 10;

    const SERVICE_CHARGE = 0.10;
    const VAT = 0.05;

    const getTourismFee = () => {
        return Number(booking?.hotel?.rating) === 5 ? 20 : 10;
    };

    useEffect(() => {
        if (!orderId) return;

        axios.get(`https://hotel.southtravels.com/api/verify-payment/${orderId}`)
            .then(res => {
                if (res.data.booking) {
                    setBooking(res.data.booking);
                }

                if (res.data.status === "pending") {
                    setTimeout(() => window.location.reload(), 2000);
                }
            })
            .catch(err => console.error(err));

    }, [orderId]);

    const formatDate = (date) => {
        return new Intl.DateTimeFormat("en-GB", {
            timeZone: "Asia/Dubai",
            day: "2-digit",
            month: "short",
            year: "numeric"
        }).format(new Date(date));
    };

    const getNights = () => {
        if (!booking) return 1;

        if (booking.nights) return booking.nights;

        const start = new Date(booking.check_in);
        const end = new Date(booking.check_out);

        const diff =
            Math.ceil((end - start) / (1000 * 60 * 60 * 24));

        return diff > 0 ? diff : 1;
    };

    const nightlyRate = () => {
        return booking?.discount_price || booking?.room_price || 0;
    };

    const downloadInvoice = () => {
        if (!booking) return;

        const doc = new jsPDF();

        const primary = [37, 99, 235];
        const gray = [120, 120, 120];
        const green = [22, 163, 74];

        const left = 20;
        const right = 190;
        let y = 20;





        const roomName =
            (booking.room_name || "")
                .charAt(0)
                .toUpperCase() +
            (booking.room_name || "").slice(1);

        const nights = getNights();

        const base = Number(booking.final_nightly_price || booking.room_price || 0);


        const { serviceCharge, vat, tourismFee, total } =
            calculateCharges(base);

        const formatCurrency = (amount) =>
            new Intl.NumberFormat("en-AE", {
                style: "currency",
                currency: "AED"
            }).format(amount);

        // ===== HEADER =====
        const headerHeight = 30;
        const centerY = headerHeight / 2;

        doc.setFillColor(...primary);
        doc.rect(0, 0, 210, headerHeight, "F");

        doc.setTextColor(255, 255, 255);

        // MAIN TITLE
        doc.setFontSize(16);
        doc.text("SouthTravels", left, centerY - 2, { baseline: "middle" });

        // RIGHT TITLE
        doc.setFontSize(11);
        doc.text("Hotel Booking Invoice", right, centerY - 2, {
            align: "right",
            baseline: "middle"
        });

        // ===== SECOND ROW (with proper padding)
        const bottomPadding = 8;
        const subRowY = headerHeight - bottomPadding;

        doc.setFontSize(9);
        doc.text(`Invoice #: ${booking.order_id}`, left, subRowY);
        doc.text(`Date: ${formatDate(new Date())}`, right, subRowY, { align: "right" });

        // move content below header
        y = headerHeight + 15;





        // ===== CUSTOMER + BOOKING (2 COLUMN) =====
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(12);
        doc.text("Customer Details", left, y);
        doc.text("Booking Info", 110, y);

        y += 8;

        doc.setFontSize(10);
        doc.setTextColor(...gray);

        // Left column
        doc.text(`Name: ${booking.name}`, left, y);
        doc.text(`Email: ${booking.email}`, left, y + 7);
        doc.text(`Guests: ${booking.guests}`, left, y + 14);

        // Right column
        // doc.text(`Hotel: ${booking.hotel_name}`, 110, y - 7);
        // doc.text(`Room: ${roomName}`, 110, y);
        // doc.text(`Room No: ${booking.room?.room_number || "-"}`, 110, y + 7);
        // doc.text(`Check-in: ${formatDate(booking.check_in)}`, 110, y + 14);
        // doc.text(`Check-out: ${formatDate(booking.check_out)}`, 110, y + 21);
        // doc.text(`Nights: ${getNights()}`, 110, y + 28);

        // Right column
        const bookingStartY = y + 2;

        doc.text(`Hotel: ${booking.hotel_name}`, 110, bookingStartY);
        doc.text(`Room: ${roomName}`, 110, bookingStartY + 7);
        doc.text(`Room No: ${booking.room?.room_number || "-"}`, 110, bookingStartY + 14);
        doc.text(`Check-in: ${formatDate(booking.check_in)}`, 110, bookingStartY + 21);
        doc.text(`Check-out: ${formatDate(booking.check_out)}`, 110, bookingStartY + 28);
        doc.text(`Nights: ${getNights()}`, 110, bookingStartY + 35);

        // y += 38;
        y += 45;
        // ===== TABLE HEADER =====
        doc.setFillColor(...primary);
        doc.rect(left, y, 170, 10, "F");

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(10);

        const headerY = y + 10 / 2 + 1.5;

        doc.text("Description", left + 5, headerY);

        const rightPadding = 5;
        doc.text("Amount (AED)", right - rightPadding, headerY, { align: "right" });

        // ✅ MORE SPACE BELOW HEADER
        y += 20;

        // ===== TABLE BODY (NEW BREAKDOWN) =====
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);



        let yBody = y;

        // Base Price
        // ===== PER NIGHT ROOM PRICE =====
        doc.text("Room Price (Per Night)", left + 5, yBody);
        doc.text(formatCurrency(base), right, yBody, { align: "right" });

        yBody += 8;

        // Total Room Price (nights × base)
        doc.text("Room Price Total", left + 5, yBody);
        doc.text(formatCurrency(base * nights), right, yBody, { align: "right" });

        yBody += 8;

        // // Service Charge
        // doc.text("Service Charge (10%)", left + 5, yBody);
        // doc.text(formatCurrency(serviceCharge * nights), right, yBody, { align: "right" });

        // yBody += 8;

        // // VAT
        // doc.text("VAT (5%)", left + 5, yBody);
        // doc.text(formatCurrency(vat * nights), right, yBody, { align: "right" });

        // yBody += 8;

        // // Tourism Fee
        // // doc.text("Tourism Fee", left + 5, yBody);
        // doc.text(
        //     `Tourism Fee ${Number(booking?.hotel?.rating) === 5 ? "(5★ Hotel)" : ""}`,
        //     left + 5,
        //     yBody
        // );
        // doc.text(formatCurrency(tourismFee * nights), right, yBody, { align: "right" });

        // yBody += 10;

        // Service Charge
        doc.text("Service Charge (10%)", left + 5, yBody);
        doc.text(formatCurrency(serviceCharge), right, yBody, {
            align: "right"
        });

        yBody += 8;

        // VAT
        doc.text("VAT (5%)", left + 5, yBody);
        doc.text(formatCurrency(vat), right, yBody, {
            align: "right"
        });

        yBody += 8;

        // Tourism Fee
        doc.text(
            `Tourism Fee ${Number(booking?.hotel?.rating) === 5 ? "(5★ Hotel)" : ""}`,
            left + 5,
            yBody
        );

        doc.text(formatCurrency(tourismFee), right, yBody, {
            align: "right"
        });

        yBody += 10;

        // Divider line
        doc.setDrawColor(220);
        doc.line(left, yBody, right, yBody);

        yBody += 10;

        // TOTAL
        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);

        doc.text("TOTAL", left + 5, yBody);
        doc.text(formatCurrency(total * nights), right, yBody, { align: "right" });

        // move cursor down
        y = yBody + 15;

        // ===== FOOTER =====
        const footerY = 270;

        doc.setDrawColor(220);
        doc.line(left, footerY - 10, right, footerY - 10);

        doc.setFontSize(9);
        doc.setTextColor(...gray);

        doc.text("Thank you for booking with us!", left, footerY);
        doc.text("support@southtravels.com", left, footerY + 6);

        // ===== SAVE =====
        doc.save(`invoice-${booking.order_id}.pdf`);
    };

    const formatCurrency = (amount) =>
        new Intl.NumberFormat("en-AE", {
            style: "currency",
            currency: "AED"
        }).format(amount);

    const [showLoginPopup, setShowLoginPopup] = useState(false);

    const handleMyBookingsClick = () => {
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user) {
            setShowLoginPopup(true);
            return;
        }

        window.location.href = "/profile";
    };


    const getFinalNightlyRate = () => {
        const base = Number(booking?.final_nightly_price || booking?.room_price || 0);

        const serviceCharge = base * SERVICE_CHARGE;
        const vat = base * VAT;

        // return base + serviceCharge + vat + TOURISM_FEE;
        return base + serviceCharge + vat + getTourismFee();
    };

    const getBasePrice = () => {
        return Number(booking?.final_nightly_price || booking?.room_price || 0);
    };
    const base = getBasePrice();
    const nights = getNights();
    const b = calculateCharges(base);





    return (
        <div style={styles.page}>
            <div style={styles.card} id="booking-card">

                {/* ✅ Success Icon */}
                <div style={styles.icon}>✅</div>

                <h1 style={styles.title}>Payment Successful</h1>
                <p style={styles.subtitle}>
                    Your booking is confirmed. We’ll contact you shortly.
                </p>

                {!booking ? (
                    <div style={styles.loading}>
                        <div className="flex flex-col items-center gap-3">
                            <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
                            <p>Loading booking details...</p>
                        </div>
                    </div>
                ) : (
                    <>
                        {/* ✅ Booking Info */}
                        <div style={styles.section}>
                            <h3 style={styles.sectionTitle}>Booking Details</h3>

                            <div style={styles.row}>
                                <span>Name : </span>
                                <span>{booking.name}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Email : </span>
                                <span>{booking.email}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Hotel : </span>
                                <span>{booking.hotel_name}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Room : </span>
                                <span>{booking.room_name}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Room Details : </span>
                                <span style={{ fontWeight: "600" }}>
                                    {booking.room_number || "-"}
                                </span>
                            </div>

                            <div style={styles.row}>
                                <span>Guests : </span>
                                <span>{booking.guests}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Check-in : </span>
                                <span>{formatDate(booking.check_in)}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Check-out : </span>
                                <span>{formatDate(booking.check_out)}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Nights : </span>
                                <span>{getNights()}</span>
                            </div>

                            <div style={styles.row}>
                                <span>Rate Per Night : </span>
                                <span>
                                    AED {Math.round(base)} × {nights} night(s)
                                </span>
                            </div>
                        </div>

                        {/* ✅ Pricing Box */}
                        <div style={styles.priceBox}>
                            {/* <p>
                                Standard Room Price (Before Seasonal Pricing Applied): AED {Math.round(Number(booking.room_price || 0))}
                            </p> */}

                            <div style={{ marginTop: "10px" }}>
                                <p style={{ fontWeight: "600", marginBottom: "6px" }}>
                                    Price Breakdown
                                </p>

                                {(() => {
                                    const b = calculateCharges(
                                        Number(booking?.final_nightly_price || booking?.room_price || 0)
                                    );

                                    return (
                                        <>
                                            <p>Base Price: AED {b.base}</p>

                                            <p>Service Charge (10%): AED {b.serviceCharge}</p>

                                            <p>VAT (5%): AED {b.vat}</p>

                                            {/* <p>Tourism Fee: AED {b.tourismFee}</p> */}

                                            <p>
                                                Tourism Fee
                                                {Number(booking?.hotel?.rating) === 5 ? " (5★ Hotel)" : ""}:
                                                AED {b.tourismFee}
                                            </p>

                                            <hr style={{ margin: "10px 0" }} />

                                            <p style={{ fontWeight: "600" }}>
                                                Total Per Night: AED {b.total}
                                            </p>
                                        </>
                                    );
                                })()}
                            </div>

                            {booking.discount_price && (
                                <p style={{ color: "#16a34a", fontWeight: "600" }}>
                                    Discounted: AED {Math.round(Number(booking.discount_price))}
                                </p>
                            )}

                            <p>
                                Nights: <strong>{getNights()}</strong>
                            </p>

                            <p>
                                Price Calculation:
                                <strong>
                                    {" "}
                                    AED {Math.round(Number(getFinalNightlyRate()))} ×{" "}
                                    {getNights()} night(s)
                                </strong>
                            </p>

                            {/* <div style={styles.total}>
                                💳 Total Paid: {Math.round(b.total * nights)}
                            </div> */}

                            <div style={styles.total}>
                                💳 Total Paid: AED {Math.round(b.total * nights)}
                            </div>

                            <p
                                style={{
                                    marginTop: "10px",
                                    fontSize: "13px",
                                    color: "#555"
                                }}
                            >
                                ℹ Tourism fee applied:
                                AED {getTourismFee()}
                                {Number(booking?.hotel?.rating) === 5
                                    ? " for 5★ hotel"
                                    : " standard hotel fee"}
                            </p>

                            <div
                                style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    gap: "10px",
                                    justifyContent: "center"
                                }}
                            >
                                <button
                                    style={styles.primaryBtn}
                                    onClick={() => (window.location.href = "/")}
                                >
                                    🏠 Home
                                </button>

                                <button
                                    style={styles.secondaryBtn}
                                    onClick={handleMyBookingsClick}
                                >
                                    📖 My Bookings
                                </button>
                            </div>

                            <div style={styles.actions}>
                                <button
                                    style={styles.primaryBtn}
                                    onClick={downloadInvoice}
                                >
                                    <Download size={18} style={{ marginRight: "6px" }} />
                                    Download Receipt
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {showLoginPopup && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <div style={{
                        background: "#fff",
                        padding: "30px",
                        borderRadius: "12px",
                        textAlign: "center",
                        width: "320px"
                    }}>
                        <h3 style={{ marginBottom: "10px" }}>🔐 Login Required</h3>
                        <p style={{ color: "#555" }}>
                            You must login or sign up to view your bookings.
                        </p>

                        <div style={{
                            marginTop: "20px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            {/* Login Button */}
                            <button
                                onClick={() => {
                                    setShowLoginPopup(false);
                                    onLoginClick();
                                }}
                                style={styles.primaryBtn}
                            >
                                Login
                            </button>

                            <button
                                onClick={() => {
                                    setShowLoginPopup(false);
                                    onLoginClick();
                                }}
                                style={{
                                    ...styles.secondaryBtn,
                                    border: "1px solid #2563eb",
                                    color: "#2563eb",
                                    fontWeight: "600"
                                }}
                            >
                                Sign Up
                            </button>

                            {/* Cancel */}
                            <button
                                onClick={() => setShowLoginPopup(false)}
                                style={{
                                    marginTop: "10px",
                                    background: "transparent",
                                    border: "none",
                                    color: "#888",
                                    cursor: "pointer"
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #4facfe, #00f2fe)",
        padding: "20px"
    },

    card: {
        background: "#fff",
        padding: "35px",
        borderRadius: "16px",
        boxShadow: "0 15px 40px rgba(0,0,0,0.15)",
        width: "600px",
        textAlign: "center",
        animation: "fadeIn 0.4s ease-in-out"
    },

    icon: {
        fontSize: "40px",
        marginBottom: "10px"
    },

    title: {
        margin: 0,
        fontSize: "24px",
        fontWeight: "700",
        color: "#111"
    },

    subtitle: {
        color: "#666",
        marginTop: "8px",
        marginBottom: "20px"
    },

    loading: {
        marginTop: "20px",
        color: "#555",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    section: {
        textAlign: "left",
        marginTop: "20px",
        padding: "15px",
        borderRadius: "10px",
        background: "#f9fafb",
        border: "1px solid #eee"
    },

    sectionTitle: {
        marginBottom: "10px",
        fontSize: "16px",
        fontWeight: "600"
    },

    row: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "8px",
        fontSize: "14px"
    },

    priceBox: {
        marginTop: "20px",
        padding: "15px",
        borderRadius: "10px",
        background: "#f0fdf4",
        border: "1px solid #bbf7d0",
        textAlign: "left"
    },

    total: {
        marginTop: "10px",
        fontSize: "18px",
        fontWeight: "700",
        color: "#065f46"
    },

    actions: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginTop: "20px"
    },

    primaryBtn: {
        background: "#2563eb",
        color: "#fff",
        border: "none",
        padding: "10px 16px",
        borderRadius: "8px",
        cursor: "pointer",
        fontWeight: "600",
        display: "flex",
        alignItems: "center"
    },

    secondaryBtn: {
        background: "#f3f4f6",
        color: "#111",
        border: "1px solid #ddd",
        padding: "10px 16px",
        borderRadius: "8px",
        cursor: "pointer"
    }
};